// extracted by mini-css-extract-plugin
module.exports = {"root":"MiniSplash_root__BE5cd","contain":"MiniSplash_contain__fT__a","mobile":"MiniSplash_mobile__CTLCE","desktop":"MiniSplash_desktop__nuqEi"};